import {
  GET_ADMIN_USER_REQUEST,
  GET_ADMIN_USER_SUCCESS,
  GET_ADMIN_USER_FAILURE,
  UPDATE_ADMINUSER_INPUT
} from '../actions/AdminUser'

let initialState = {
  usersForm: {
    accountType: "student"
  },
  users: [],
  loading: false
}

export default (state = initialState, action) => {
  switch(action.type) {
    case GET_ADMIN_USER_REQUEST:
      return state = Object.assign({}, state, {
        loading: action.loading
      })
    case GET_ADMIN_USER_SUCCESS:
      return state = Object.assign({}, state, {
        loading: action.loading,
        users: action.body.users
      })
    case GET_ADMIN_USER_FAILURE:
      return state = Object.assign({}, state, {
        loading: action.loading,
        error: action.error
      })
    case UPDATE_ADMINUSER_INPUT:
      var usersForm = state.usersForm
      usersForm[action.key] = action.value
      return state = Object.assign({}, state, {
        usersForm: usersForm
      })
    default:
      return state
  }

}



// WEBPACK FOOTER //
// ./src/reducers/AdminUser.js